import React, {Component} from 'react';
import './style/schedule.css';
import $ from 'jquery';

class Schedule extends Component {
    constructor(props) {
        super(props);

        this.btnClicked = false;
        this.onMouseDown = this.onMouseDown.bind(this);
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseUp = this.onMouseUp.bind(this);
        this.onItemClick = this.onItemClick.bind(this);
        this.onMouseUpOutside = this.onMouseUpOutside.bind(this);
        this.setVolume = this.setVolume.bind(this);
        this.groupClick = this.groupClick.bind(this);
        this.saveData = this.saveData.bind(this);
        this.setData = props.setData;
    }

    getDays(scheduleArr) {
        const res = [];

        if (scheduleArr.length) {
            for (let i = 0; i < 7; i++) {
                res.push(scheduleArr.filter(function (item) {
                    return item.day === i;
                }));
            }
        }

        return res;
    }

    getGroupDays(days) {
        const groupDayData = [];
        days.forEach(function (day) {
            let prevValue;
            let group = { items: [], volume: undefined };
            let dayGroup = [];

            day.forEach(function (item, i) {
                const isLastHour = day.length === (i + 1);

                if (i === 0) {
                    prevValue = item.volume;
                    group.volume = item.volume;
                    group.items.push(item);
                    return;
                }

                if (item.volume === prevValue) {
                    group.items.push(item);
                }

                if (item.volume !== prevValue || isLastHour) {
                    dayGroup.push(group);
                    group = { items: [item], volume: item.volume };
                }

                if (item.volume !== prevValue && isLastHour) {
                    dayGroup.push(group);
                }

                prevValue = item.volume;
            });
            groupDayData.push(dayGroup);
        });
        return groupDayData;
    }

    initSelectBlock(e) {
        const target = $(e.target);
        const dayBlock = target.parents('.day');
        const block = dayBlock.find('.selectBlock');
        const selectedItem = dayBlock.find('.selected');
        const selectedItemGroup = selectedItem.parent();
        let middlePos;

        if (block.length && selectedItem.length && selectedItemGroup.length) {
            middlePos = selectedItemGroup[0].offsetTop + (selectedItem[0].offsetTop + selectedItem[selectedItem.length - 1].offsetTop) / 2;
            selectedItem.addClass('hidePrice');
            block.addClass('show');
            block.find('input').focus();
            block.css('top', middlePos + 'px');
        }
    }

    hideSelectBlock() {
        $('.selectBlock').removeClass('show');
    }

    setVolume(e) {
        const data = this.props.state.data;
        const target = $(e.target);
        const input = target.prev();
        const inputVal = input.val();
        const selectedItem = target.parents('.day').find('.selected');
        const selectedId = [];

        e.preventDefault();
        e.stopPropagation();

        if (!inputVal) {
            input.css('border', '1px solid red');
            return;
        }

        selectedItem.each(function () {
            const id = $(this).attr('data-id');
            if (id) {
                selectedId.push(parseInt(id, 10));
            }
        });

        data.forEach((item) => {
            if (selectedId.indexOf(item.id) > -1) {
                item.volume = parseInt(inputVal, 10);
            }
        });
        input.val('');
        this.props.changeState({ data });
        this.removeSelection();
        this.hideSelectBlock();
        this.hideGroupItems();
    }

    saveData(e) {
        e.preventDefault();
        this.setData(this.props.state.data)
            .then((data) => {
                this.props.changeState({
                    saveState: {
                        pending: 'done',
                        status:  data.status,
                    },
                });

                setTimeout(() => {
                    this.props.changeState({
                        saveState: {
                            pending: false,
                            status:  '',
                        },
                    });
                }, 3000);
            });
    }

    removeSelection() {
        document
            .querySelectorAll('.selected')
            .forEach((node) => {
                if (node.classList) {
                    node.classList.remove('selected');
                }
            });
    }

    hideGroupItems() {
        $('.showItem').removeClass('showItem');
    }

    groupClick(e) {
        const group = $(e.target);
        this.hideGroupItems();
        group.addClass('showItem');
    }

    onMouseDown(e) {
        e.preventDefault();
        e.stopPropagation();
        this.btnClicked = true;
        this.removeSelection();
        this.hideSelectBlock();
        $('.hidePrice').removeClass('hidePrice');
        e.target.classList.toggle('selected');
    }

    onMouseEnter(e) {
        const target = $(e.target);
        const fromElm = $(e.nativeEvent.target);

        if (!this.btnClicked) {
            return;
        }

        if (fromElm.is('.selected') && target.is('.selected')) {
            fromElm.removeClass('selected');
        } else if (target.next('.selected').length || target.prev('.selected').length) {
            target.toggleClass('selected');
        }
    }

    onItemClick(e) {
        e.stopPropagation();
        this.btnClicked = false;
    }

    onMouseUp(e) {
        e.preventDefault();
        e.stopPropagation();
        this.btnClicked = false;
        this.initSelectBlock(e);
    }

    onMouseUpOutside(e) {
        this.btnClicked = false;
        this.removeSelection();
        this.hideSelectBlock();
        this.hideGroupItems();
    }

    render() {
        const schedule = this.props.state.data || [];
        const daysData = this.getGroupDays(this.getDays(schedule));
        const timePeriod = [
            '00:00-00:59',
            '01:00-01:59',
            '02:00-02:59',
            '03:00-03:59',
            '04:00-04:59',
            '05:00-05:59',
            '06:00-06:59',
            '07:00-07:59',
            '08:00-08:59',
            '09:00-09:59',
            '10:00-10:59',
            '11:00-11:59',
            '12:00-12:59',
            '13:00-13:59',
            '14:00-14:59',
            '15:00-15:59',
            '16:00-16:59',
            '17:00-17:59',
            '18:00-18:59',
            '19:00-19:59',
            '20:00-20:59',
            '21:00-21:59',
            '22:00-22:59',
            '23:00-23:59',
        ];
        const daysName = [
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
            'Sunday',
        ];


        return (
            <div className="defaultWrapper" onMouseUp={this.onMouseUpOutside}>
                {daysData.length ? <form>
                    <div className="wrapper_row">
                        <div className="fullwidth">
                            <div className="scheduleWrapper">
                                <div className="time">
                                    <div className="head">
                                        Time period
                                    </div>
                                    {timePeriod.map((item, i) => <div className="item" key={i}>{item}</div>)}
                                </div>
                                {daysName.map((item, i) => (
                                    <div className="day" key={i}>
                                        <div className="selectBlock"><label>
                                            <input onMouseDown={(e) => e.stopPropagation()}
                                                   onMouseUp={(e) => e.stopPropagation()}
                                                   type="number"/>
                                            <button
                                                onClick={this.setVolume}
                                                onMouseUp={(e) => e.stopPropagation()}>Set
                                            </button>
                                        </label></div>
                                        <div className="head">
                                            {item}
                                        </div>
                                        {daysData[i].map((group, i) => (
                                            <div className="group" key={i} onClick={this.groupClick}>
                                                <span>{group.volume}</span>
                                                {group.items.map((item, i) => (
                                                    <div className="item"
                                                         key={i}
                                                         data-id={item.id}
                                                         onClick={this.onItemClick}
                                                         onMouseUp={this.onMouseUp}
                                                         onMouseEnter={this.onMouseEnter}
                                                         onMouseDown={this.onMouseDown}
                                                    >{item.volume}</div>
                                                ))}
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="wrapper_row right-align">
                        {this.props.state.saveState.pending === true ? (<div className="state pending">
                            <div className="icon spinner"></div>
                            saving...</div>) : ''}
                        {this.props.state.saveState.pending === 'done' ?
                            <div className="state">{this.props.state.saveState.status === 'ok' ? <div
                                className="normalContent">Saved!</div> : this.props.state.saveState.status}</div> : ''}
                        <div className="btn-wrapper">
                            <button onClick={this.saveData} className="btn btn-primary">Save changes</button>
                        </div>
                    </div>
                </form> : <div className="loading">Loading...</div>}
            </div>
        );
    }
};
export default Schedule;



